'use strict';

module.exports = function sortByDesc(valueOrFunction) {
  return this.sortBy(valueOrFunction).reverse();
};


//////////////////
// WEBPACK FOOTER
// ./~/collect.js/dist/methods/sortByDesc.js
// module id = 292
// module chunks = 0